/* eslint-disable jsx-a11y/alt-text */
import React, { useState } from "react";
import styled from "styled-components";
import Section from "../components/Section";
import Colors from "../theme/colors";
import graphic from "../images/graphic.png";
import Metrics from "../theme/metrics";
import TopBar from "../components/Navigation";
import {ArrowForward} from '@styled-icons/ionicons-outline/ArrowForward'
import CountrySelect from "../components/CountrySelect"
import SelectCountry from "../components/SelectCountry"

const Half = styled.div`
  width: 100%;
  h2 {
    font-weight: 600;
    font-size: 24px;
    margin: 0 0 24px 0;
  }
  p {
    max-width: 400px;
    font-size: 16px;
    color: ${Colors.Trust.Black};
    opacity: 0.8;
    line-height: 22px;
  }

  @media screen and (min-width: ${Metrics.Breakpoints.medium}) {
    width: 50%;
  }
`;
const Img = styled.img`
  width: 100%;
  margin: 24px 0;
`;

const Form = styled.form`
  label {
    font-size: 14px;
    opacity: 0.5;
  }

  input[type="text"] {
    box-sizing: border-box;
    display: block;
    width: 100%;
    border: 2px solid #e4e7e7;
    border-radius: 4px;
    max-width: 360px;
    padding: 12px 16px;
    background-color: rgba(255, 255, 255, 1);
    color: ${Colors.Neutral.Black};
    font-size: 16px;
    transition: all 0.5s ease-in-out;
    outline: none;

    :focus {
      border: 2px solid ${Colors.Trust.Primary};
    }
  }

  input[type="file"] {
    box-sizing: border-box;
    content: "Upload your icon";
    color: black;
    background-color: white;
    width: 100%;
    height: 48px;
    padding: 12px 16px;
    max-width: 360px;
    border-radius: 4px;
    border: 2px solid #e4e7e7;

    :focus {
      border: 2px solid ${Colors.Trust.Primary};
    }

    ::file-selector-button {
      display: none;
    }
  }
`;

const Button = styled.button`
  background-color: ${Colors.Trust.Primary};
  color: white;
  border: none;
  font-size: 16px;
  padding: 12px 16px;
  border-radius: 5px;
  margin-top: 18px;
  display: flex;

  svg {
    align-items: center;
    padding-left: 5px;
  }
`;

const Disclosure = styled.p`
  font-size: 12px;
  color: #B8B8C3;
  max-width: 440px;
`

const Start = ({
  activateSDK,
  applicationName,
  setApplicationName,
  setAppIcon,
  appIcon,
  country,
  setCountry
}) => {
  const [imgValue, setImgValue] = useState("");

  const updateApplicationName = (evt) => {
    setApplicationName(evt.target.value);
  };

  const updateAppIcon = (evt) => {
    setAppIcon(URL.createObjectURL(evt.target.files[0]));
    setImgValue(evt.target.value);
  };

  return (
    <>
      <TopBar />
      <Section>
        <Half>
          <h2>Welcome to the Lean Demo</h2>
          <p>
            Experience a user connecting a bank account using Link SDK and take
            a look at the data an app would consume.
          </p>
          <Form>
            <label>Application Name</label>
            <input
              type="text"
              autoComplete="off"
              value={applicationName ? applicationName : ""}
              onChange={(e) => updateApplicationName(e)}
            />
            <label>Application Icon</label>
            <input
              type="file"
              id="appIcon"
              name="application icon"
              accept="image/png, image/jpeg"
              value={imgValue}
              onChange={(e) => updateAppIcon(e)}
            />
            <label>Choose country</label>
            <CountrySelect>
              <SelectCountry onClick={() => setCountry("ARE")} active={country === "ARE"}>🇦🇪 UAE</SelectCountry>
              <SelectCountry onClick={() => setCountry("SAU")} active={country === "SAU"}>🇸🇦 KSA</SelectCountry>
            </CountrySelect>
          </Form>
          <Button onClick={() => activateSDK()}>Connect Account<ArrowForward size={"18"}/></Button>
          <br></br>
          <br></br>
        </Half>
        <Half>
          <Img src={graphic} />
        </Half>
      </Section>
      <Section>
          <Disclosure>The Lean Demo and any content found herein is not endorsed by, directly affiliated with, maintained, authorized, or sponsored by any financial institution (unless explicitly stated otherwise). All company names are the registered trademarks of their original owners.</Disclosure>
      </Section>
    </>
  );
};

export default Start;
